import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateField,
  List,
  ReferenceField,
  ShowButton,
  EditButton,
  TextField,
  BooleanField,
  TextInput,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [<TextInput label="Search" source="code" alwaysOn />];

export const ExternalIsolatesList = withStyles(styles)(
  ({ classes, ...props }) => (
    <List
      {...props}
      filters={filters}
      actions={<MyListActions />}
      pagination={<MyListPagination />}
      perPage={100}
    >
      <Datagrid>
        <TextField label="Code" source="code" />

        <TextField label="Code external" source="code_external" />

        <TextField label="Type external" source="type_external" />

        <TextField label="Specie" source="specie" />

        <TextField label="Study source" source="study_source" />

        <ReferenceField
          label="Provider"
          source="id_provider"
          reference="providers"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>

        <DateField label="Study date" source="study_date" locales="es-UY" />

        <TextField label="Notes" source="notes" />

        <DateField
          source="createdAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        <DateField
          source="updatedAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        <EditButton />
        <ShowButton />
      </Datagrid>
    </List>
  )
);
